import React from 'react'
import PropTypes from 'prop-types'
import { ApolloProvider } from 'react-apollo'
import { hot } from 'react-hot-loader'
import 'isomorphic-fetch'

import '../../utils/lifecycle'
import * as sentry from '../../utils/sentry'
import { getSpaVersion } from '../../utils/spa-version'
import apolloClient from '../../apollo/apollo-client'
import DevApp from './DevApp'
import { OnlineOrderingApp } from './OnlineOrderingApp'
import { MultiLocationPickerApp } from './MultiLocationPickerApp'
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary'
import { OOGlobalsProvider } from '../OOGlobalsProvider/OOGlobalsProvider'
import { AuthProvider } from '../AuthProvider/AuthProvider'
import 'react-toastify/dist/ReactToastify.css'
import 'slick-carousel/slick/slick.css'

sentry.init({
  publicKey: '33b889f63e6643cd9e970b491d574d5a',
  projectId: '1319042'
})

const App = ({
  location = window.location,
  ooGlobals = window.OO_GLOBALS || {
    devError: {
      message: 'Could not find OO_GLOBALS.'
    },
    enabledFeatureFlags: []
  }
}) => {
  const useDevApp = !(
    ooGlobals.routerBasename &&
    location.pathname.startsWith(ooGlobals.routerBasename)
  )
  const isUsingMLP = ooGlobals.mode === 'MLP'
  const spaVersion = getSpaVersion()
  return (
    <ErrorBoundary>
      <ApolloProvider client={apolloClient}>
        {useDevApp ? (
          <DevApp />
        ) : (
          <OOGlobalsProvider
            devError={ooGlobals.devError}
            enabledFeatureFlags={ooGlobals.enabledFeatureFlags}
            gatewayBaseUri={ooGlobals.gatewayBaseUri}
            outpostIdentifier={ooGlobals.outpostIdentifier}
            toastwebBaseUri={ooGlobals.toastwebBaseUri}
            restaurantGuid={ooGlobals.restaurantGuid}
            routerBasename={ooGlobals.routerBasename}
            shortUrl={ooGlobals.shortUrl}
            spaVersion={spaVersion.current}
            spaPreviousVersion={spaVersion.previous}
            mode={ooGlobals.mode}
            managementGroupGuid={ooGlobals.managementGroupGuid}
            mapboxAccessToken={ooGlobals.mapboxAccessToken}
            toastTakeoutCTAEnabled={Boolean(ooGlobals.toastTakeoutCTAEnabled)}
          >
            <AuthProvider>
              {isUsingMLP
                ? <MultiLocationPickerApp />
                : <OnlineOrderingApp />
              }
            </AuthProvider>
          </OOGlobalsProvider>
        )}
      </ApolloProvider>
    </ErrorBoundary>
  )
}

App.propTypes = {
  // Intended to be window.location
  location: PropTypes.shape({
    pathname: PropTypes.any.isRequired
  }),
  ooGlobals: PropTypes.object
}

export default hot(module)(App)
